import { faCaretUp } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { seasonsHistogram } from 'types/Recipe/Recipe';

interface IProps {
	seasonsHistogram: seasonsHistogram;
}

const intervals = {
	medium: 60,
	high: 80,
};

const colors = {
	low: '#ffcaa7',
	medium: '#fde79d',
	high: '#97dbbd',
};

function getColor(value: number): string {
	return value <= intervals.medium
		? colors.low
		: value > intervals.medium && value <= intervals.high
		? colors.medium
		: colors.high;
}

const SeasonalityHistogram = (props: IProps) => {
	const { t } = useTranslation();

	const monthNames = useMemo(
		() => [
			t('months:JANUARY'),
			t('months:FEBRUARY'),
			t('months:MARCH'),
			t('months:APRIL'),
			t('months:MAY'),
			t('months:JUNE'),
			t('months:JULY'),
			t('months:AUGUST'),
			t('months:SEPTEMBER'),
			t('months:OCTOBER'),
			t('months:NOVEMBER'),
			t('months:DECEMBER'),
		],
		[t]
	);

	const currentMonthNumber = new Date().getMonth();

	if (props.seasonsHistogram[0] != null) {
		const histogramValues = Array.from({ length: 12 }, (_, i) => {
			const value = props.seasonsHistogram[i];
			return Math.round(Math.ceil(value * 100));
		});

		return (
			<div>
				<label style={{ display: 'flex' }}>
					{t('seasonality:SEASONALITY')}:{' '}
					<div
						style={{
							color: getColor(histogramValues[currentMonthNumber]),
							marginLeft: '4px',
							fontWeight: 'bolder',
						}}
					>
						{histogramValues[currentMonthNumber] <= intervals.medium
							? t('seasonality:LOW')
							: histogramValues[currentMonthNumber] > intervals.medium &&
							  histogramValues[currentMonthNumber] <= intervals.high
							? t('seasonality:MEDIUM')
							: t('seasonality:HIGH')}
					</div>
				</label>
				<div className="seasonality-bar" style={{ marginTop: '5px' }}>
					{histogramValues.map((value, i) => (
						<div
							key={monthNames[i]}
							className="seasonality-bar-element"
							title={monthNames[i]}
						>
							<div
								id="square"
								style={{
									backgroundColor: getColor(value),
								}}
							></div>
							{i == currentMonthNumber ? (
								<FontAwesomeIcon style={{ color: 'blue' }} icon={faCaretUp} />
							) : (
								<div id="symbol" style={{ color: 'black' }}>
									{i + 1}
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		);
	} else {
		return (
			<div>
				<label style={{ display: 'flex' }}>
					{t('seasonality:SEASONALITY')}:{' '}
					<Spinner
						animation="border"
						role="status"
						variant="primary"
						size="sm"
						style={{ marginLeft: '1rem' }}
					></Spinner>
				</label>
				<div className="seasonality-bar" style={{ marginTop: '5px' }}>
					{monthNames.map((month, i) => (
						<div key={i} className="seasonality-bar-element" title={month}>
							<div id="square"></div>
							<div id="symbol" style={{ color: 'black' }}>
								{i + 1}
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}
};

export default SeasonalityHistogram;
